import { useGetMyPastReservations } from "@/api/user/useGetMyUpcomingReservations";
import { PastReservations } from "@/components/EventReservation/MyReservations/PastReservation";
import { UpcomingReservations } from "@/components/EventReservation/MyReservations/UpcomingReservation";
import { Flex, Tabs, Text, Title } from "@mantine/core";
import { useLocation, useNavigate } from "react-router-dom";

export function HomeMyReservationsPage() {
  const location = useLocation();
  const navigate = useNavigate();

  // Determine active tab from URL path
  const activeTab = location.pathname.includes("/past") ? "past" : "upcoming";

  const {
    data: pastReservations,
    isPending: isPastReservationsPending,
    isFetching: isPastReservationsFetching,
    isError: isPastReservationsError,
  } = useGetMyPastReservations({ enabled: activeTab === "past" });

  // If user visits /home/event, redirect to /home/event/upcoming
  if (location.pathname === "/home/reservation") {
    navigate("/home/reservation/upcoming", { replace: true });
    return null;
  }

  const handleTabChange = (value: string | null) => {
    if (value === "upcoming") {
      navigate("/home/reservation/upcoming");
    } else if (value === "past") {
      navigate("/home/reservation/past");
    }
  };

  return (
    <Tabs
      value={activeTab}
      onChange={handleTabChange}
      style={{
        display: "flex",
        flexDirection: "column",
        height: "100%",
        tab: {
          "&:hover": {
            backgroundColor: "red !important",
            border: "5px solid red !important",
          },
        },
      }}
    >
      <Flex justify="start" direction="column" gap={20} pb="lg">
        <div></div>
        <Title ta="center">오프에서 함께할 이벤트에요 💌</Title>
        <Text size="md" c="white" ta="center">
          함께할 오프 멤버들과의 초대 확정이 되면 문자로 가장 먼저 알려드릴게요.
        </Text>
      </Flex>
      <Tabs.List grow>
        <Tabs.Tab value="upcoming">다가오는 오프</Tabs.Tab>
        <Tabs.Tab value="past">지난 오프</Tabs.Tab>
      </Tabs.List>

      {activeTab === "upcoming" && <UpcomingReservations />}
      {activeTab === "past" && pastReservations && <PastReservations />}
    </Tabs>
  );
}
